<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 31 32"
  >
    <defs>
      <filter
        id="a"
        width="150%"
        height="148.1%"
        x="-25%"
        y="-24.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5" />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" filter="url(#a)" transform="translate(3 3)">
      <path
        fill="#FFF"
        d="M6.992 12.17h6.764c.682 0 1.234-.563 1.234-1.257s-.552-1.256-1.234-1.256H6.992c-.681 0-1.233.562-1.233 1.256s.552 1.257 1.233 1.257"
      />
      <path
        fill="#FFF"
        d="M11.608 14.359V7.468c0-.694-.553-1.257-1.234-1.257-.681 0-1.233.563-1.233 1.257v6.89c0 .695.552 1.257 1.233 1.257s1.234-.562 1.234-1.256"
      />
      <g transform="translate(4.167 .219)">
        <path
          fill="#FFF"
          d="M14.86 16.245c.071-.072.134-.155.188-.247 2.355-4.033 1.766-9.154-1.417-12.53a.94.94 0 0 0-.05-.052l-.143-.147a1.59 1.59 0 0 0-.053-.05C10.072-.025 5.045-.625 1.086 1.773a1.27 1.27 0 0 0-.43 1.722 1.22 1.22 0 0 0 1.69.438c3.04-1.84 6.907-1.353 9.42 1.185 2.49 2.559 2.969 6.5 1.162 9.595a1.27 1.27 0 0 0 .43 1.722c.495.3 1.112.206 1.502-.19"
        />
      </g>
      <path
        fill="#FFF"
        d="M15.64 19.914c.39-.396.482-1.025.187-1.53a1.22 1.22 0 0 0-1.69-.438c-3.039 1.841-6.907 1.353-9.419-1.184-2.49-2.56-2.97-6.5-1.163-9.596a1.27 1.27 0 0 0-.43-1.721 1.22 1.22 0 0 0-1.69.437C-.918 9.916-.33 15.036 2.854 18.412l.05.053.144.147a.938.938 0 0 0 .052.05c3.313 3.243 8.34 3.843 12.298 1.444.09-.054.172-.12.243-.192"
      />
      <g transform="translate(17.188 18.26)">
        <path
          fill="#FFF"
          d="M7.145 7.06a1.273 1.273 0 0 0 0-1.776L2.598.65a1.217 1.217 0 0 0-1.744 0 1.272 1.272 0 0 0 0 1.777L5.401 7.06c.482.49 1.262.49 1.744 0"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EnlargeIcon',
};
</script>
